export default __webpack_public_path__ + "static/media/Google2.84049a4f.PNG";